// this.$store.state.conductor
import { serverTimestamp } from "firebase/firestore";

// CONDUCTORES
export const conductor = class {
  constructor() {
    return {
      id: "",
      idUsuario: "",
      idEmpresa: "",
      idLider: "",
      tiposVehiculosConduceOperacion: [],
      vehiculos: [],
      dispositivoZonaCliente: "",
      conRodamiento: "Si",
      conduceVehiculo: "Si",
      sinRodamiento: {
        apellido: "",
        cargo: "",
        correo: "",
        documento: {
          numero: 0,
          tipo: "",
        },
        nombre: "",
      },
      registro: {
        idUsuario: "",
        creacion: serverTimestamp(),
        actualizacion: serverTimestamp(),
        estado: "Creado",
      },
    };
  }
};
